function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M97.0797 36.9598L118.26 61.0798C118.26 60.6598 118.26 60.2398 118.26 59.8198C118.26 27.4798 92.0396 1.25977 59.6996 1.25977C27.3596 1.25977 1.13965 27.4798 1.13965 59.8198C1.13965 89.5798 23.3396 114.18 52.1396 117.9L23.3996 85.1398L97.0797 36.9598Z",
  fill: "#EAA622"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M118.259 61.08L97.0794 36.96L23.3994 85.1399L52.1394 117.9C54.5994 118.2 57.1194 118.38 59.6994 118.38C91.6194 118.38 117.599 92.88 118.259 61.08Z",
  fill: "#BF830D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M97.0794 36.96H23.3994V85.14H97.0794V36.96Z",
  fill: "#D7D7D7"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M23.3994 85.1401L60.2394 52.6201L97.0794 85.1401H23.3994Z",
  fill: "#636363"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3994 36.96L60.2394 74.52L97.0794 36.96H23.3994Z",
  fill: "white"
});

var SvgByMail = function SvgByMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgByMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/by_mail.7e9e9c9f.svg";
export { ForwardRef as ReactComponent };